import React from 'react';
import PropTypes from 'prop-types';

import Browser from '@wetransfer/concorde-browser';

import ReceivingExperimentVariantHeader from './variant/header';
import ReceivingExperimentVariantStickyAppbar from './variant/sticky-appbar';
import ReceivingExperimentVariantAppbar from './variant/appbar';

import Analytics from '@module/analytics';
import LaunchDarkly from '@module/launchdarkly';

import {
  EXPERIMENT_RECEIVING_VARIANT_LARGE_HEADER,
  EXPERIMENT_RECEIVING_VARIANT_STICKY_APP_BAR,
  EXPERIMENT_RECEIVING_VARIANT_APP_BAR,
  EXPERIMENT_RECEIVING_PAGE,
} from '@constant/experiments';

const trackEvent = (propertyName) => {
  Analytics.trackStructEvent({
    category: 'transfer',
    action: 'click_open_in_app',
    property: propertyName,
  });
};

export const ReceivingExperiment = ({ experimentVariant, shortUrl }) => {
  if (
    experimentVariant !== LaunchDarkly.getVariant(EXPERIMENT_RECEIVING_PAGE) ||
    !Browser.isMobile
  ) {
    return null;
  }

  switch (experimentVariant) {
    case EXPERIMENT_RECEIVING_VARIANT_LARGE_HEADER:
      return (
        <ReceivingExperimentVariantHeader
          onClick={trackEvent}
          shortUrl={shortUrl}
        />
      );

    case EXPERIMENT_RECEIVING_VARIANT_STICKY_APP_BAR:
      return (
        <ReceivingExperimentVariantStickyAppbar
          onClick={trackEvent}
          shortUrl={shortUrl}
        />
      );

    case EXPERIMENT_RECEIVING_VARIANT_APP_BAR:
      return (
        <ReceivingExperimentVariantAppbar
          onClick={trackEvent}
          shortUrl={shortUrl}
        />
      );

    default:
      return null;
  }
};

ReceivingExperiment.propTypes = {
  experimentVariant: PropTypes.oneOf([
    EXPERIMENT_RECEIVING_VARIANT_LARGE_HEADER,
    EXPERIMENT_RECEIVING_VARIANT_STICKY_APP_BAR,
    EXPERIMENT_RECEIVING_VARIANT_APP_BAR,
  ]),
  shortUrl: PropTypes.string,
};

export default ReceivingExperiment;
